import { Navigate, Outlet, type RouteObject } from 'react-router-dom';
import type { RouterProps } from 'contracts/Router';
import { FidsTrackingRoutesPage } from 'pages/VehicleJourney/TrackingRoutes';

const fidsRoute = ({ location, userBelongsToAnyOf }: RouterProps): RouteObject =>
  ({
    path: 'painel-chegadas',
    element: <Outlet />,
    children: [
      {
        path: 'mapeamento-checkpoints',
        element: userBelongsToAnyOf('admin') ? (
          <FidsTrackingRoutesPage />
        ) : (
          <Navigate to="/" state={{ from: location }} replace />
        ),
      },
    ],
  });

export default fidsRoute;